var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAibutton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16213 3679)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 5,
    transform: "translate(-16213 -3679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.348-9.433l4.3,8.891a2.079,2.079,0,0,1,.271.813q0,.574-.924,1.036a2.09,2.09,0,0,1-.852.271.851.851,0,0,1-.51-.143.952.952,0,0,1-.287-.3Q9.26.971,9.1.653L8.273-1.068H3.859L3.03.653q-.159.319-.247.462A1.135,1.135,0,0,1,2.5,1.41a.819.819,0,0,1-.51.151,2.09,2.09,0,0,1-.852-.271Q.21.844.21.27A2.079,2.079,0,0,1,.481-.542l4.3-8.907a1.392,1.392,0,0,1,.534-.59,1.41,1.41,0,0,1,.757-.223A1.349,1.349,0,0,1,7.348-9.433ZM6.058-5.609,5.006-3.426H7.125ZM12.8-8.86a4.629,4.629,0,0,1,.024-.55,1.277,1.277,0,0,1,.151-.422q.223-.43,1.243-.43,1.115,0,1.323.59a3.169,3.169,0,0,1,.08.829V.015a4.6,4.6,0,0,1-.024.558,1.285,1.285,0,0,1-.151.414q-.223.43-1.243.43-1.115,0-1.307-.605A2.506,2.506,0,0,1,12.8,0Z",
    transform: "translate(-16206.356 -3659.187)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAibutton);
export default __webpack_public_path__ + "static/media/aibutton.adfc3ee3fb58cb6234ab47923e6e75f1.svg";
export { ForwardRef as ReactComponent };